import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, styled } from '@mui/material';
import { GoogleMap, InfoWindow, Marker, useLoadScript } from '@react-google-maps/api';
import { Link } from 'react-router-dom';
import { useFazy } from 'src/hooks/useFazy';
import { years } from 'src/utils/years';
import { Button } from '@mui/material';
import { useMemo } from 'react';
import { useEffect } from 'react';

const MapWrapper = styled('div')`
  & .map-container {
    height: 400px;
    ${({ height }) => `height:${height};`}
  }
  border-radius: 10px;
  overflow: hidden;
`;

const ButtonsWrapper = styled('div')`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 2rem;
`;

const libraries = ['places'];

const Map = ({ position, zoom, ref, height, zakazky, disableFilters, currentYear, providedYear }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries: libraries,
  });

  const { getStartingYear } = useFazy();

  const [filterYear, setFilterYear] = useState('all');
  const [selectedMarker, setSelectedMarker] = useState(null);

  const handleMarkerClick = (index) => {
    setSelectedMarker(index);
  };

  const handleInfoWindowClose = () => {
    setSelectedMarker(null);
  };

  const getColorByYear = (year) => {
    const foundYear = years.find((item) => {
      return item.year == year;
    });
    return foundYear ? foundYear.color : '#FFFFFF';
  };

  const handleFilterYearClick = (currentYear) => {
    setFilterYear((prev) => (prev === currentYear ? 'all' : currentYear));
  };

  const filteredZakazky = useMemo(() => {
    if (filterYear === 'all') {
      return zakazky;
    }
    return zakazky?.filter((item) => {
      if (filterYear === '') {
        return item?.year === null;
      }
      return item?.year == filterYear;
    });
  }, [zakazky, filterYear]);

  useEffect(() => {
    if (currentYear) {
      setFilterYear(new Date().getFullYear());
    }
  }, [currentYear]);

  useEffect(() => {
    if (providedYear) {
      setFilterYear(providedYear);
    }
  }, [providedYear && providedYear]);

  return isLoaded ? (
    <div>
      {!disableFilters && (
        <ButtonsWrapper>
          <Button
            variant="outlined"
            style={{
              backgroundColor: '#7fae04',
              opacity: filterYear === 'all' ? 1 : 0.3,
              borderColor: '#7fae04',
              color: 'white',
            }}
            onClick={() => handleFilterYearClick('all')}
          >
            Všetky
          </Button>
          {years.map((item) => (
            <Button
              key={item.year}
              onClick={() => handleFilterYearClick(item.year)}
              variant="contained"
              style={{ backgroundColor: item.color, opacity: filterYear === item.year ? 1 : 0.4 }}
            >
              {item.year}
            </Button>
          ))}
          <Button
            variant="outlined"
            style={{
              backgroundColor: '#FFFFFF',
              opacity: filterYear === '' ? 1 : 0.3,
              borderColor: '#000000',
              color: '#000000',
            }}
            onClick={() => handleFilterYearClick('')}
          >
            Nezaradené
          </Button>
        </ButtonsWrapper>
      )}
      <MapWrapper ref={ref} height={height}>
        <GoogleMap zoom={zoom} center={position} mapContainerClassName="map-container">
          {!filteredZakazky && <Marker position={position} />}
          {filteredZakazky &&
            filteredZakazky.map(
              (zakazka, index) =>
                zakazka.lat &&
                zakazka.lng && (
                  <Marker
                    onClick={() => handleMarkerClick(index)}
                    position={{ lat: Number(zakazka.lat), lng: Number(zakazka.lng) }}
                    key={zakazka.id}
                    icon={{
                      url: `/assets/markers/${getColorByYear(zakazka?.year)?.substring(1) ?? 'FFFFFF'}.svg`,
                    }}
                    /*icon={{
                      url: 'assets/markers/marker.svg',
                      path: window.google.maps.SymbolPath.BACKWARD_CLOSED_ARROW, // Use the default marker symbol
                      fillColor: getColorByYear(getStartingYear(zakazka)), // Set your desired color here
                      fillOpacity: 1,
                      strokeColor: getStartingYear(zakazka) ? 'white' : 'black', // Set stroke color if needed
                      strokeWeight: 1,
                      scale: 8, // Adjust the scale as needed
                    }}*/
                  >
                    {selectedMarker === index && (
                      <InfoWindow onCloseClick={handleInfoWindowClose}>
                        <>
                          <Typography fontWeight="700" fontSize="14px">
                            {zakazka.number}
                          </Typography>
                          <Typography>{zakazka.clientName}</Typography>
                          <Link to={`/sprava/zakazky/detail/${zakazka.id}`}>Zobraziť detail</Link>
                        </>
                      </InfoWindow>
                    )}
                  </Marker>
                )
            )}
        </GoogleMap>
      </MapWrapper>
    </div>
  ) : (
    <></>
  );
};

Map.propTypes = {
  position: PropTypes.object,
  zoom: PropTypes.number,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Map.defaultProps = {
  zoom: 7,
};

export default Map;
